export { default } from './resolveComponentProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/resolveComponentProps/index.js
// module id = 381
// module chunks = 22